module.exports = __webpack_public_path__ + "img/bullock.27548311.jpg";